import * as ContactDataSX from '@aibees/elephant/components/people-contact-data/sx';
import { LabelManagementProvider } from '@aibees/elephant/components/search-table-action-dialog-lists/context';
import { RecordManagementLabels } from '@aibees/elephant/feature/search-drawer/components/record-management-labels';
import { LabelType } from '@aibees/elephant/types/label';
import { Icon } from '@aibees/shared/components';
import { useBoolean } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { Stack, Typography } from '@mui/material';
import { merge } from 'lodash-es';
import { memo, useCallback, useState } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { AccountAccordionProps as Props } from './types';

export const AccountAccordion = memo(
  ({
    className,
    closeAble,
    closeTitle,
    icon,
    withLabelManagement,
    title,
    children,
    summarySx,
    detailSx,
    titleSx,
  }: Props) => {
    const [labelCount, setLabelCount] = useState(0);

    const handleLabelCountChange = useCallback((count: any) => {
      setLabelCount(count);
    }, []);

    const state = useBoolean(true);

    const handelExpand = () => {
      if (!closeAble) return;
      if (state.value) {
        state.onFalse();
      } else state.onTrue();
    };

    const closeAbleTitle = state.value ? 'Close' : 'Open';

    return (
      <Styled.Wrapper
        className={classnames('AccountAccordion', className)}
        sx={SX.root}
      >
        <LabelManagementProvider onChangeLabels={() => {}}>
          <Styled.CustomAccordion expanded={state.value}>
            <Styled.CustomSummary
              onClick={handelExpand}
              expandIcon={
                closeAble ? (
                  <Icon
                    name="arrow-accordion"
                    onClick={handelExpand}
                    size={15}
                    color={state.value ? 'grey.500' : 'primary.500'}
                  />
                ) : null
              }
              sx={merge(ContactDataSX.summary(state.value), summarySx)}
            >
              <Stack direction="row" alignItems="center" gap={0.5}>
                {icon ? (
                  <Icon name={icon} />
                ) : (
                  <Stack
                    justifyContent="center"
                    alignItems="center"
                    // sx={ContactDataSX.badge(state.value)}
                  >
                    {labelCount}
                  </Stack>
                )}

                <Typography color="grey.800" variant="body3">
                  {closeTitle && closeAbleTitle} {title}
                </Typography>
              </Stack>
            </Styled.CustomSummary>
            <Styled.DetailWrapper
              sx={merge(SX.accDetail(state.value), detailSx)}
            >
              {children}
              {withLabelManagement && (
                <Stack gap={0.5} sx={SX.content}>
                  <Typography variant="body4" color="grey.500">
                    Labels
                  </Typography>
                  <RecordManagementLabels
                    onCountChange={handleLabelCountChange}
                    labelType={LabelType.LABEL}
                    iconAddButton="label"
                  />
                </Stack>
              )}
            </Styled.DetailWrapper>
          </Styled.CustomAccordion>
        </LabelManagementProvider>
      </Styled.Wrapper>
    );
  }
);

AccountAccordion.displayName = 'AccountAccordion';
